module.exports = __webpack_public_path__ + "static/media/dashboard_icon_active.ee5c1278.svg";